import Preloader from '../../components/Preloader';
import Navigation from '../../components/Navigation';
import CaseSlider from '../../components/case/CaseSlider';
import Brands from '../../components/Brands';
import TeamSlider from '../../components/team/TeamSlider';
import Footer from '../../components/Footer';
import usePage from '../../framework/hooks/usePageHook';
import WhatWeDo from '../../components/WhatWeDo';
import PageHeader from '../../components/header/PageHeader';

export default function CaseOverview({ page }) {
    const pageObj = usePage(page.id);

    if (!page) return <Preloader />;

    return (
        <>
            <Navigation page={page} />
            <PageHeader title={page.paginatitel} description={page.inhoud} />
            <CaseSlider pro />
            <Brands />
            <TeamSlider />
            <Footer />
        </>
    );
}
